import { Injectable } from '@angular/core';
import {
	COMMISSION_STATEMENT_BLURBS,
	APS_BLURBS,
	EREG_BLURBS,
	FIRE_INSURANCE_BLURBS,
} from '@models/document-processing-loading-text';
import { MatterDocumentType } from '@models/matter-file';

@Injectable({
	providedIn: 'root',
})
export class DocumentAITextLoadingUIService {
	getLoadingMetaData(
		matterDocumentType: MatterDocumentType,
	): [string[], number] {
		let progressBarMessages: string[] = [];
		let estimatedLoadingTime = 10000;
		switch (matterDocumentType) {
			case MatterDocumentType.BUYER_COMMISSION_STATEMENT:
			case MatterDocumentType.SELLER_COMMISSION_STATEMENT: {
				progressBarMessages = COMMISSION_STATEMENT_BLURBS;
				break;
			}
			case MatterDocumentType.APS: {
				progressBarMessages = APS_BLURBS.sort(() => Math.random() - 0.5).slice(
					0,
					7,
				);
				estimatedLoadingTime = 35000;
				break;
			}
			case MatterDocumentType.EREG_CHARGE:
			case MatterDocumentType.EREG_TRANSFER:
			case MatterDocumentType.ADDITIONAL_REGISTER:
			case MatterDocumentType.ASSIGNMENT_OF_RENTS:
			case MatterDocumentType.GENERAL_SECURITY_AGREEMENT: {
				progressBarMessages = EREG_BLURBS;
				break;
			}
			case MatterDocumentType.FIRE_INSURANCE: {
				progressBarMessages = FIRE_INSURANCE_BLURBS.sort(
					() => Math.random() - 0.5,
				).slice(0, 4);
				estimatedLoadingTime = 20000;
				break;
			}
		}

		return [progressBarMessages, estimatedLoadingTime];
	}
}
